import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, List, ListItem, Modal, Stack, Typography } from '@mui/material'
import React from 'react';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useQueryClient } from 'react-query';
import FillLabelTxtField from '../../../components/FillLabelTxtField';
import { customAlert, notify } from '../../../components/notify';
import ScrollBox from '../../../components/ScrollBox';
import { useAuthContext } from '../../../context/AuthContext';
import { DragHandle } from '@mui/icons-material';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { addReportConfig } from '../../../services/bo-service';
import CustomDropDown from '../../../components/CustomDropDown';
import { getReportFields, reportTypeArr } from '../../../utils/reportTypeFields';


function AddReportConfig({ modalOpen, handleModalClose }) {

    const [formErrors, setFormErrors] = useState({});
    const { setLoadingScreen } = useAuthContext();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const [selEleArr, setSelEleArr] = useState([])
    const [reportType, setReportType] = useState("shipment");
    const fieldsArr = getReportFields(reportType);

    function handleTypeChange(e) {
        setReportType(e.target.value || "shipment");
        setSelEleArr([]);
    }

    let txtFieldProps = { fontSize: 14, height: 38, width: 520 };

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        inputObject.selEleArr = selEleArr;
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);

        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {

            await addReportConfig({
                configName: inputObject.configName,
                config: selEleArr,
                reportType
            });
            notify("success", "Report Config Updated Successfully");
            handleModalClose();
            setSelEleArr([])
            queryClient.invalidateQueries();
        } catch (err) {
            // console.log(err);
            if (err === 409)
                notify("error", "Report Config Name Should be Unique");
            else
                customAlert(err);
        }
        setLoadingScreen(false)
    }

    let boxStyle = { borderRadius: 1.4, border: 1, borderColor: "rgba(0, 0, 0, 0.3)", height: 350, width: 350, mt: 0.8, pl: 3 };

    function handleEleChange(e) {
        const { value } = e.target
        let selEleObj = fieldsArr.find((i) => i.id === value)
        if (selEleArr.findIndex((i) => i.id === value) >= 0) {
            let filteredArr = selEleArr.filter((x) => x.id !== value)
            setSelEleArr([...filteredArr])
        } else {
            setSelEleArr(prevArr => [...prevArr, selEleObj])
        }
    }

    function onDragEnd(result) {
        if (!result.destination) return;

        const items = Array.from(selEleArr);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setSelEleArr(items);
    };

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={2}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>{t("sa.addReptConfig.addReptConfig")}</Typography>
                    </Stack>
                    <Stack direction={"row"} gap={3} alignItems={"flex-end"}>
                        <FillLabelTxtField name="configName" title={t("sa.addReptConfig.reptConfigName")} errMsg={formErrors.configName} {...txtFieldProps} width={400} />
                        <CustomDropDown defaultValue={reportType} handleDDChange={handleTypeChange} title={t("sa.reptConfig.reportType")} name={"reportType"} ddArr={reportTypeArr} width={300} height={38} fontSize={14} />
                    </Stack>

                    <Stack direction={"row"} mt={3} gap={5} >
                        <Stack>
                            <Typography style={{ fontWeight: "bold", fontSize: 14 }} >{t("sa.addReptConfig.fieldUnselect")}</Typography>
                            <Box sx={boxStyle}>
                                <ScrollBox height={"100%"}>
                                    <FormControl>
                                        <FormGroup>
                                            {fieldsArr.map((e) => <FormControlLabel key={e.id}
                                                label={<Typography fontSize={14}>{e.label}</Typography>}
                                                control={<Checkbox value={e.id} checked={selEleArr.findIndex((i) => i.id === e.id) >= 0} onChange={handleEleChange} />}
                                            />)}
                                        </FormGroup>
                                    </FormControl>
                                </ScrollBox>
                            </Box>
                        </Stack>

                        <Stack>
                            <Typography style={{ fontWeight: "bold", fontSize: 14, color: formErrors.selEleArr && "red" }} >{t("sa.addReptConfig.fieldSelect")}
                                <Typography component={"span"} sx={{ color: "red", fontSize: 13 }}>{formErrors.selEleArr} </Typography>
                            </Typography>
                            <Box sx={boxStyle}>
                                <ScrollBox height={"100%"}>
                                    <DragDropContext onDragEnd={onDragEnd}>
                                        <Droppable style={{ transform: "none" }} droppableId='addelements' >
                                            {(provided) => (
                                                <List  {...provided.droppableProps} ref={provided.innerRef} >
                                                    {selEleArr.map((e, index) => (
                                                        <Draggable key={e.id} draggableId={e.id} index={index}>
                                                            {(provided, snapshot) => {
                                                                if (snapshot.isDragging) {
                                                                    provided.draggableProps.style.left = provided.draggableProps.style.offsetLeft;
                                                                    provided.draggableProps.style.top = provided.draggableProps.style.offsetTop;
                                                                }
                                                                return (
                                                                    <ListItem ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}  >
                                                                        <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                                                            <Typography fontSize={14}>{e.label}</Typography>
                                                                            <DragHandle />
                                                                        </Stack>
                                                                    </ListItem>
                                                                )
                                                            }}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </List>
                                            )
                                            }
                                        </Droppable>
                                    </DragDropContext>
                                </ScrollBox>
                            </Box>
                        </Stack>
                    </Stack>


                    <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={"100%"}>
                        <Button variant="text" sx={{ height: 40, width: 120 }} onClick={handleModalClose}>{t("sa.addReptConfig.cancel")}</Button>
                        <Button variant="contained" type='submit' sx={{ height: 40, width: 150 }}>{t("sa.addReptConfig.save")}</Button>
                    </Stack>
                </Box>
            </form>
        </Modal>
    )
}

export default AddReportConfig;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 3,
    py: 2,
    borderRadius: 2
};

function validate(values) {
    const errors = {};

    if (!values.configName)
        errors.configName = "Config Name is required!";

    if ((values.selEleArr).length <= 0)
        errors.selEleArr = "- (Fields Required)";

    return errors;
};